import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Button, Container, FormGroup } from "reactstrap";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import TabPanel from "components/TabPanel";
import TabView from "components/TabView";
import { validate } from "components/validateGeneralForm";
import Dados from "./Dados";
import Anexos from "./Anexos";
import ModalSelecionarLocalizacao from "./Dados/ModalSelecionarLocalizacao";

import TitleFormWithEdit from "components/TitleFormWithEdit";
import { showLoading } from "components/Loading";
import { hideLoading } from "components/Loading";
import { erroInesperado } from "services/Utils";
import { toast } from "react-toastify";
import cruzamentoService from "services/CruzamentoService";
import comboService from "services/ComboService";
import AppContext from "AppContext";
import Cameras from "./Cameras";
import Componentes from "./Componentes";

export default function FormCruzamento() {
  const { state } = useContext(AppContext)
  const [data, setData] = useState({
    idContrato: state?.contrato?.id,
  })
  const [edit, setEdit] = useState(false)
  const [modalLocalizacaoAberto, setModalLocalizacaoAberto] = useState(false)
  const [cruzamentosDoContrato, setCruzamentosDoContrato] = useState([])
  const params = useParams()
  const navigate = useNavigate()
  const formRef = useRef(null)
  const [searchParams] = useSearchParams()

  const id = parseInt(params.id)
  const novo = (0 === id)

  const carregar = () => {
    cruzamentoService.getById(id).then(res => {
      if (res.success) {
        setData(res.data)
      }
    })
  }

  const podeGerenciar = useMemo(() => {
    return (state?.user?.acoes || []).includes('cruzamento.gerenciar')
  }, [state])

  useEffect(() => {
    if (!!id) {
      carregar()
    } else {
      setData({ idContrato: state?.contrato?.id })
    }
  }, [id])

  useEffect(() => {
    if (novo) {
      setEdit(true)
    }
  }, [novo])

  useEffect(() => {
    if (!data.idContrato) {
      setCruzamentosDoContrato([])
      return
    }
    comboService.cruzamento(data.idContrato).then(res => {
      if (res.success) {
        setCruzamentosDoContrato(res.data)
      }
    })
  }, [data.idContrato])

  const formConfig = useMemo(() => {
    return [
      [
        { name: "numero", label: 'Número', type: "text", required: true, colspan: 4 },
        { name: "endereco", label: 'Endereço', type: "text", required: true, colspan: 8 },
        { name: "lat", label: 'Latitude', type: "signeddecimal", required: true, colspan: 3, decimals: 5 },
        { name: "lng", label: 'Longitude', type: "signeddecimal", required: true, colspan: 3, decimals: 5 },
        {
          name: "selecionarLocalizacao",
          type: "view",
          colspan: 1,
          component: (fieldProps) => (
            <FormGroup>
              <label>&nbsp;</label>
              <div>
                <Button
                  type="button"
                  color="secondary"
                  outline
                  onClick={() => setModalLocalizacaoAberto(true)}
                  disabled={fieldProps.formDisabled}
                  title="Selecionar localização no mapa"
                >
                  <i className="bi bi-geo-alt-fill" />
                </Button>
              </div>
            </FormGroup>
          )
        },
        {
          name: "idCruzamentoMestre", label: 'Cruzamento Mestre', type: "combo", colspan: 5,
          options: cruzamentosDoContrato.filter(c => c.id != data.id),
          optionValue: 'id', optionLabel: 'numero', showDefault: true,
          disabled: !!data.temEscravos,
        },
      ],
    ]
  }, [data, cruzamentosDoContrato])

  const abaAtual = () => {
    if (searchParams.get('aba') == 'cameras')
      return 3
    if (searchParams.get('aba') == 'componentes')
      return 2
    return 1
  }

  const handleChange = (field, value) => {
    setData(data => ({ ...data, [field]: value }))
  }

  const enviar = async () => {
    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData(data => ({ ...data, errors }))
      // erros foram encontrados
      return
    }

    try {
      showLoading()
      if (novo) {
        await cruzamentoService.create(data)
      } else {
        await cruzamentoService.update(id, data)
      }
      toast('Registro salvo com sucesso!')
      hideLoading()
      navigate('/admin/cruzamentos')
    } catch (ex) {
      hideLoading()
      console.error(ex)
      erroInesperado()
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    await enviar()
  }

  return (
    <Container fluid>
      <TitleFormWithEdit title="Cruzamentos" edit={edit} onChangeEdit={setEdit} showButton={!novo && podeGerenciar} />
      <TabView defaultTab={abaAtual()}>
        <TabPanel label="Dados">
          <form onSubmit={handleSubmit} ref={formRef}>
            <Dados data={data} onChange={handleChange} formConfig={formConfig} edit={edit} />
            {edit && (
              <div className="text-right">
                <Button type="submit" color="primary">Salvar</Button>
              </div>
            )}
          </form>
          <ModalSelecionarLocalizacao
            isOpen={modalLocalizacaoAberto}
            lat={data.lat}
            lng={data.lng}
            onConfirm={(lat, lng) => {
              handleChange('lat', lat)
              handleChange('lng', lng)
            }}
            onClose={() => setModalLocalizacaoAberto(false)}
          />
        </TabPanel>
        <TabPanel label="Componentes" disabled={id == 0}>
          <Componentes cruzamento={data} onChange={() => carregar()} edit={edit} />
        </TabPanel>
        <TabPanel label="Câmeras" disabled={id == 0}>
          <Cameras idCruzamento={id} onChange={() => carregar()} edit={edit} />
        </TabPanel>
        <TabPanel label="Anexos" disabled={id == 0}>
          <Anexos idCruzamento={id} onChange={() => carregar()} edit={edit} />
        </TabPanel>
      </TabView>
    </Container>
  )
}
